import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

export const COOKIE_CONSENT_KEY = 'creditoolsmx-cookie-consent';

function saveConsent(accepted) {
  try {
    window.localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify({ accepted, answeredAt: new Date().toISOString() })
    );
  } catch (error) {
    // Storage can fail in private contexts; the current choice still applies.
  }

  window.dispatchEvent(new CustomEvent('creditoolsmx:cookie-consent', { detail: { accepted } }));
}

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = window.localStorage.getItem(COOKIE_CONSENT_KEY);
      if (!consent) {
        setIsVisible(true);
      }
    } catch (error) {
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    document.body.classList.toggle('cookie-consent-pending', isVisible);
    return () => document.body.classList.remove('cookie-consent-pending');
  }, [isVisible]);

  const handleAccept = () => {
    saveConsent(true);
    setIsVisible(false);
  };

  const handleReject = () => {
    saveConsent(false);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <aside className="cookie-banner" aria-live="polite" aria-label="Aviso de cookies">
      <div className="cookie-banner__content">
        <div>
          <strong>Tu privacidad importa.</strong>
          <p>
            Con tu permiso usamos analítica para mejorar el sitio. Consulta nuestra{' '}
            <Link to="/cookies">Política de Cookies</Link>.
          </p>
        </div>
        <div className="cookie-banner__actions">
          <button type="button" className="cookie-banner__secondary" onClick={handleReject}>
            Solo necesarias
          </button>
          <button type="button" className="btn-cta" onClick={handleAccept}>
            Aceptar analítica
          </button>
        </div>
      </div>
    </aside>
  );
}
